import { BehaviorSubject } from 'rxjs';
import { environment } from '@env/environment';
import { switchMap } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { Store } from '@ngrx/store';
import { TokenRestore, AuthInit, LoggedOnce } from '../store/auth/auth.actions';
var ROLE_ADMIN = 1;
var USER_TOKEN = 'token';
var USER_LOGGED_ONCE = 'logged_once';
var AuthTokenService = /** @class */ (function () {
    function AuthTokenService(storage, store) {
        var _this = this;
        this.storage = storage;
        this.store = store;
        this.token$ = new BehaviorSubject(null);
        this.dumpToken = function (token) {
            // environment.log.auth &&
            //   console.log("\n\n\n================\ndump auth token", token);
            return !!token
                ? _this.storage.set(USER_TOKEN, token)
                : _this.storage.remove(USER_TOKEN).then(function () { return null; });
        };
        this.updateLoggedOnce = function (token) {
            return _this.storage.get(USER_LOGGED_ONCE).then(function (loggedOnce) {
                if (token || loggedOnce) {
                    _this.store.dispatch(new LoggedOnce(true));
                    return loggedOnce
                        ? token
                        : _this.storage.set(USER_LOGGED_ONCE, Date.now()).then(function (_) { return token; });
                }
                else {
                    return Promise.resolve(token);
                }
            });
        };
    }
    AuthTokenService.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.store.dispatch(new AuthInit());
            _this.storage.get(USER_TOKEN).then(function (token) {
                environment.log.auth &&
                    console.log((!!token ? "logged" : "not logged") + " at boot");
                if (!!token) {
                    try {
                        var payload = _this.readPayload(token);
                        _this.store.dispatch(new TokenRestore(payload));
                    }
                    catch (error) {
                        token = null;
                    }
                }
                _this.token = token;
                _this.token$
                    .pipe(switchMap(_this.dumpToken), switchMap(_this.updateLoggedOnce))
                    .subscribe(function () { });
                resolve(token);
            }, function (error) {
                resolve(null);
            });
        });
    };
    Object.defineProperty(AuthTokenService.prototype, "token", {
        get: function () {
            return this.token$.value;
        },
        set: function (value) {
            this.token$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    AuthTokenService.prototype.readPayload = function (token) {
        var payload = this.getTokenPayload(token);
        return payload; // && payload.user ? Object.assign({roles: [], id: null},
        // {id: payload.user.id, roles: JSON.parse(payload.user.roles)}) : null
    };
    AuthTokenService.prototype.getTokenPayload = function (token) {
        return token
            //? JSON.parse(this.b64DecodeUnicode(token.split(".")[1]))
            ? token
            : null;
    };
    AuthTokenService.prototype.b64DecodeUnicode = function (str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str)
            .split("")
            .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(""));
    };
    return AuthTokenService;
}());
export { AuthTokenService };
export function AuthTokenFactory(service) {
    return function () { return service.load(); };
}
